export type NetworkBand = "fast" | "medium" | "slow" | "unknown";

/** Map only effectiveType; missing support (including WKWebView) stays unknown. */
export function networkBand(effectiveType: unknown): NetworkBand {
  switch (effectiveType) {
    case "4g":
      return "fast";
    case "3g":
      return "medium";
    case "2g":
    case "slow-2g":
      return "slow";
    default:
      return "unknown";
  }
}
